import { Drawer, createDrawer } from '@nexelem/drawer';
import { useCustomTranslation } from '../../../../hooks';
import { SearchChip } from '@nexelem/inputs';
import { useDelayedState } from '@nexelem/utils';
import { SearchResults } from './SearchResults';

const ProductionPlanSearchDrawer = () => {
  const { t, tWrapper } = useCustomTranslation('products.productionPlan');

  const [search, delayedSearch, setSearch] = useDelayedState('');

  return (
    <Drawer>
      <Drawer.Header
        title={<div className="text-t24-sb">{tWrapper('search')}</div>}
        onClose={closeProductionPlanSearchDrawer}
      >
        <SearchChip className="mt-4" placeholder={t('common.search')} value={search} onChange={setSearch} />
      </Drawer.Header>
      <Drawer.Content className="overflow-hidden px-0 pb-0">
        <SearchResults search={delayedSearch} />
      </Drawer.Content>
      <Drawer.Footer />
    </Drawer>
  );
};

export const { toggleProductionPlanSearchDrawer, closeProductionPlanSearchDrawer } = createDrawer(
  ProductionPlanSearchDrawer,
  {
    name: 'ProductionPlanSearchDrawer',
    slot: 'left',
    width: 420,
    drawerId: () => 'production-plan-search-drawer',
  },
);
